export const ACTIVATION_LINK_USED_MESSAGE =
  'Este link de ativação já foi utilizado. Caso precise de ajuda, entre em contato com o suporte.';

export const ACTIVATION_LINK_INVALID_MESSAGE =
  'Não foi possível validar este link de ativação. Verifique se o endereço está correto ou entre em contato com o suporte.';

export const ACTIVATION_UNEXPECTED_ERROR_MESSAGE =
  'Não foi possível concluir o cadastro neste momento. Tente novamente.';

export const ACTIVATION_SUCCESS_MESSAGE =
  'Cadastro realizado com sucesso. Enviamos um link de confirmação para o e-mail informado. Acesse sua caixa de entrada para ativar sua conta.';
